import { Dialog, Transition, TransitionChild } from "@headlessui/react";
import React, { Fragment } from "react";

const Modal = ({ isOpen, closeModal, children }) => {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-[9999]" onClose={closeModal}>
        {/* Arka plan Overlay */}
        <Transition.Child>
          <div className="fixed inset-0 bg-[#1f2937] bg-opacity-30" />
        </Transition.Child>
        {/* Modal İçeriği */}
        <Transition.Child
          as={Fragment}
          enter="transition-opacity duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          {children}
        </Transition.Child>
      </Dialog>
    </Transition>
  );
};

export default Modal;
